module.exports = __webpack_public_path__ + "static/media/sense4001.50f736de.jpg";